import axios from "axios";

export const state = {
    reportappointments: [],
};

export const getters = {
    reportappointments: state => state.reportappointments,
};

export const mutations = {
    setReportAppointment(reportappointments, newValue) { state.reportappointments = newValue},
};

export const actions = {
    fetchReportAppointment({ commit }) {
        axios.get('/reportappointments').then(res => {
            commit('setReportAppointment', res.data.appointments)
        })
    },
    filterReportAppointment({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportappointments";
        axios.post(url, formData).then((response) => {
            commit('setReportAppointment', response.data.appointments)
        })
    },
};
